import React, { useState } from 'react';
import { LOCAL_STORAGE_USER_TYPE } from '../../../../../../shared/http/auth';
import { USER_TYPES } from '../../../../../Admin/shared/static-options';

import { CheckCircleIcon, CancelIcon } from './icons';

import {
  AllowanceContainer,
  FormContent,
  ControlLabel,
  ListContainer,
  ListContent,
  ListItem,
  UserInfo,
  DateAndTimeInfo,
  EmpytContent,
} from './style';

const AllowanceRelease = ({ handleSubmit, allowanceList }) => {
  const [isChecked, setIsChecked] = useState(true);
  const [disable, setDisable] = useState(true);

  const getLastItem = allowanceList.data.map(i => i.isAllowance);
  const getLastItemFilter = getLastItem[getLastItem.length - 1];

  const onSubmit = (e) => {
    e.preventDefault();
    handleSubmit(isChecked, new Date());
    setDisable(true);
  };

  const userType = window.localStorage.getItem(LOCAL_STORAGE_USER_TYPE);

  return (
    <AllowanceContainer>
      {USER_TYPES.CUSTOMER_SERVICE_USER === Number(userType) ? (
        <React.Fragment>
          <FormContent onSubmit={onSubmit}>
            <h2>Abono de performance</h2>
            <ControlLabel>
              {getLastItemFilter === undefined ? (
                <input
                  type="checkbox"
                  onChange={(e) => {
                    setIsChecked(!!e.target.checked);
                    setDisable(false);
                  }}
                  defaultChecked
                />
              ) : null}

              {getLastItemFilter + 1 ? (
                <input
                  type="checkbox"
                  onChange={(e) => {
                    setIsChecked(!!e.target.checked);
                    setDisable(false);
                  }}
                  defaultChecked={getLastItemFilter}
                />
              ) : null}
              <span>Abono acatado pelo cliente</span>
            </ControlLabel>

            <button type="submit" disabled={disable}>
              Salvar
            </button>
          </FormContent>

          <ListContainer>
            <h2>Histórico de alteração</h2>

            {allowanceList.data.length ? (
              <ListContent>
                {allowanceList.data.map((item, idx) => (
                  <ListItem key={Number(idx)}>
                    <div>
                      <DateAndTimeInfo>
                        <span>
                          {new Intl.DateTimeFormat('pt-BR').format(new Date(item.date))}
                        </span>
                        •
                        <span>
                          {new Intl.DateTimeFormat('pt-BR', {
                            hour: 'numeric',
                            minute: 'numeric',
                          }).format(new Date(item.date))}
                        </span>
                      </DateAndTimeInfo>
                      <UserInfo>{item.user}</UserInfo>
                    </div>
                    <i>
                      {item.isAllowance === true ? (
                        <CheckCircleIcon />
                      ) : (
                        <CancelIcon />
                      )}
                    </i>
                  </ListItem>
                ))}
              </ListContent>
            ) : (
              <EmpytContent>
                <span> Nenhuma alteração feita</span>
              </EmpytContent>
            )}
          </ListContainer>
        </React.Fragment>
      ) : null}
    </AllowanceContainer>
  );
};

export default AllowanceRelease;
